import { PathOptions } from "leaflet";

export const eol_expansao_planejada = (feature: any): PathOptions => {
  return {
    color: "#87CEEB",
    weight: 2,
    opacity: 0.8,
    fillColor: "#4682B4",
    fillOpacity: 0.4,
  };
};
